export const offices = [
	{
		id: 1,
		slug: "bogota",
		name: "BOGOTÁ",
		shortName: "Bogotá",
		mapImage: "/images/maps/bogota.jpg",
		dir: "Carrera 106 # 23g - 18",
		details: "Más detalles",
		urlMap:
			"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.6738177326033!2d-74.12233278573677!3d4.65213654337333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9b8b94b727d7%3A0x452bdca6e89677c1!2sCl.%2021%20%2369b-94%2C%20Bogot%C3%A1!5e0!3m2!1ses-419!2sco!4v1633278403027!5m2!1ses-419!2sco",
		tels: [],
	},
	{
		id: 2,
		slug: "medellin",
		name: "MEDELLÍN",
		shortName: "Medellín",
		mapImage: "/images/maps/medellin.jpg",
		dir: "Calle 9 Sur # 50FF - 165",
		details: "Estos son detalles",
		urlMap:
			"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1983.2435458957511!2d-75.5867091010572!3d6.1992869098871894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e4429c1b88135c5%3A0xe8f2e03a2709fb86!2sEnergy%20Log%C3%ADstica!5e0!3m2!1ses-419!2sco!4v1783056939710!5m2!1ses-419!2sco",
		tels: ["2812333"],
	},
	{
		id: 3,
		slug: "cartagena",
		name: "CARTAGENA",
		shortName: "Cartagena",
		mapImage: "/images/maps/cartagena.jpg",
		dir: "Transversal 44 # 21 - 35, oficina 301, Edificio Empresarial Bosque",
		details: "Estos son detalles",
		urlMap:
			"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3924.246520400441!2d-75.52328658571548!3d10.40198486883885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef6258c62d5ef0d%3A0x8e4a47dc90d56645!2sTv.%2044%20%2321-35%2C%20Cartagena%2C%20Provincia%20de%20Cartagena%2C%20Bol%C3%ADvar!5e0!3m2!1ses-419!2sco!4v1633278630309!5m2!1ses-419!2sco",
		tels: ["6931985"],
	},
	{
		id: 4,
		slug: "buenaventura",
		name: "BUENAVENTURA",
		shortName: "Buenaventura",
		mapImage: "/images/maps/buena.jpg",
		dir: "Calle 7 # 4-22, oficina 205",
		details: "Estos son detalles",
		urlMap:
			"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1673.647400679509!2d-77.07576926323698!3d3.8898988092257194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e37238bc9ada0fd%3A0x76425031d56fc043!2sCl.%207%20%234-22%2C%20Buenaventura%2C%20Valle%20del%20Cauca!5e0!3m2!1ses-419!2sco!4v1633292404084!5m2!1ses-419!2sco",
		tels: [],
	},
];

export const getOfficeBySlug = (slug) => {
	return offices.find((office) => office.slug === slug) || offices[0];
};
